import { render, staticRenderFns } from "./FieldLists.vue?vue&type=template&id=b5b45962&"
import script from "./FieldLists.vue?vue&type=script&lang=js&"
export * from "./FieldLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports